module.exports = __webpack_public_path__ + "img/object-feature-distraction-after.ed0c4058.webp";